import { createSelector } from '@ngrx/store';

import { selectAuthState } from '../core.state';
import { AuthState } from './auth.models';

export const selectAuth = createSelector(
  selectAuthState,
  (state: AuthState) => state
);

export const selectAuthToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.token
);

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated
);
export const selectAuthError = createSelector(
  selectAuthState,
  (state: AuthState) => state.error
);

export const selectAuthControlledUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.controlledUser
);

export const selectAuthUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.user
);
export const selectUserMenu = createSelector(
  selectAuthState,
  (state: AuthState) => state.menu
);
